import { SVGProps } from 'react';

const ContactUsPlus = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0H10V10H0V12L10 12V22H12V12L22 12V10H12V0Z" fill="#2A2A2A" />
    </svg>
);

export default ContactUsPlus;

